<template>
	<div id="energyRightBottom2">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">用能对比</span>
				</div>
			</div>
			<div class="d-flex jc-end">
				<el-date-picker v-model="targetYear" value-format="yyyy" type="year" placeholder="选择年" @change="timeChange"></el-date-picker>
				<el-date-picker v-model="compareYear" value-format="yyyy" type="year" placeholder="对比年" @change="timeChange"></el-date-picker>
			</div>
			<div class="box-content d-flex jc-around">
				<div class="left pl-2">
					<div id="energyBottomChart" style="width: 100%; height: 4.5rem;"></div>
				</div>
				<div class="right">
					<dv-scroll-board :config="config" style="width: 95%; height: 4rem;margin: 0 auto;" />
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import echarts from "echarts"
	export default {
		components: {

		},
		data() {
			return {
				chart: null,
				config: {
					rowNum: 12, //表格行数
					headerHeight: 30,
					headerBGC: "#085E7D", //表头
					oddRowBGC: "#0f1325", //奇数行
					evenRowBGC: "#171c33", //偶数行
					index: false,
					align: ["center", "center", "center", "center"],
				},
				targetYear: String(this.getNowTime()),
				compareYear: String(this.getNowTime()-1),
				targetChart: [],
				compareChart: [],
			};
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.monthEnergy();
				},
			}
		},
		mounted() {
			this.monthEnergy();
		},
		methods: {
			timeChange(){
				this.monthEnergy()
			},
			async monthEnergy() {
				let dataObj = {
					buildingId: this.building,
					targetYear: this.targetYear,
					compareYear: this.compareYear,
				}
				await this.$axios.get("/api/buildings/monthEnergy", {
					params: dataObj
				}).then(res => {
					let compareChart = [];
					let targetChart = [];
					let dataList = [];
					let headerList = ["月份", this.targetYear + '年', this.compareYear + '年', "增减"];
					for (let key in res.data.data.compare_year) {
						targetChart.push(-(res.data.data.this_year[key].toFixed()));
						compareChart.push(res.data.data.compare_year[key].toFixed());
						dataList.push([
							key,
							res.data.data.this_year[key].toFixed(),
							res.data.data.compare_year[key].toFixed(),
							res.data.data.this_year[key]==0?'-100%':
							((res.data.data.this_year[key] - res.data.data.compare_year[key])/res.data.data.this_year[key]*100).toFixed(0) + '%'
						])
					}
					this.targetChart = targetChart.reverse();
					this.compareChart = compareChart.reverse();
					this.config = {
						header: headerList,
						data: dataList,
						rowNum: 12, //表格行数
						headerHeight: 30,
						headerBGC: "#085E7D", //表头
						oddRowBGC: "#0f1325", //奇数行
						evenRowBGC: "#171c33", //偶数行
						index: false,
						align: ["center", "center", "center", "center"],
					};
					this.draw();
				})
			},
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("energyBottomChart"), 'dark'
				);
				let targetYear = this.targetYear;
				let compareYear = this.compareYear;
				let targetChart = this.targetChart;
				let compareChart = this.compareChart;

				let option = {
					backgroundColor: 'rgba(255,255,255,0)', //背景色
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						},
						formatter: function(params) {
							return params[0].axisValueLabel + '月' + "<br />" +
								targetYear + '年：' + (-targetChart[params[0].dataIndex]) + "<br />" +
								compareYear + '年：' + compareChart[params[1].dataIndex]
						}
					},
					legend: {
						data: [this.targetYear + '年', this.compareYear + '年']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'value',
						min: -150000,
						max: 150000,
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						axisLabel: {
							show: false
						}
					}],
					yAxis: [{
						show: true, //纵坐标显示
						type: 'category',
						position: 'left', //纵向坐标显示位置 可选为：left | right
						axisTick: {
							show: false
						},
						splitLine: {
							show: false //网格线不显示
						},
						data: ['12', '11', '10', '9', '8', '7', '6', '5', '4', '3', '2', '1']
					}],
					series: [{
							name: this.targetYear + '年',
							type: 'bar',
							barWidth: 10,
							stack: 'total',
							showBackground: true,
							backgroundStyle: {
								color: 'rgba(180, 180, 180, 0.2)'
							},
							// label: {
							// 	normal: {
							// 		show: true,
							// 		/*
							// 		 *处理横坐标负半轴这边的  "柱状"  显示的数
							// 		 *后台传过来是负数，显示时是正数
							// 		 */
							// 		formatter: function(value) {
							// 			if (value.data < 0) {
							// 				return -value.data;
							// 			}
							// 		},
							// 	},
							// },
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: "#1EDFDF"
									}, {
										offset: 1,
										color: "#1B6D76"
									}], false)
								}
							},
							data: this.targetChart
						},
						{
							name: this.compareYear + '年',
							type: 'bar',
							barWidth: 10,
							stack: 'total',
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: "#184D80"
									}, {
										offset: 0.5,
										color: "#188DFA"
									}], false)
								}
							},
							data: this.compareChart
						}
					]
				};

				this.chart.setOption(option);
			},
			getNowTime() {
				var date = new Date();
				var year = date.getFullYear();
				var currentdate = year;
				// console.log(currentdate)
				return currentdate;
			},
		},
	};
</script>

<style lang="scss">
	#energyRightBottom2 {
		height: 5.65rem;
		width: 8.15rem;

		.box-content {
			width: 100%;
			height: 4.5rem;

			.left {
				width: 35%;
			}

			.right {
				width: 60%;
				padding-top: 0.4rem;
			}
			.dv-scroll-board .header{
				background: linear-gradient(rgba(0,0,0,0), #1C3B68) !important;
			}
			.rows .row-item{
				background-color: rgba(255,255,255,0) !important;
			}
		}
		.el-date-editor{
			width: 1.75rem;
			margin-right: 0.2rem;
			.el-input__inner {
				background: none;
				border: dimgray solid 1px;
				border-radius: 3px;
				color: #fff;
			
				.el-range-input {
					background: none;
					color: #fff;
				}
			
				.el-range-separator {
					color: #fff;
					margin-right: 8px;
				}
			}
		}
	}
</style>
